/**
 * @fileoverview Presentational layout for the Reports page.
 * @module pages/reports/ReportsView
 */
import styles from "../../styles/Reports.module.css";
import LanguageSelector from "../../components/LanguageSelector/index.jsx";
import NotificationBell from "../../components/NotificationBell/index.jsx";
import RoomAccomodationReportTable from "../../components/RoomAccomodationReportTable/index.jsx";
import BuyerCompanyReportTable from "../../components/BuyerCompanyReportTable/index.jsx";
import { ReactComponent as DirectoryIcon } from "../../assets/icons/Directory.svg";
import { ToastContainer } from "react-toastify";
import { REPORT_OPTION } from "../../utils/reportConstants.js";
import ReportFilterPanels from "./ReportFilterPanels.jsx";

/** Renders the Reports page from the hook view-model. */
const ReportsView = ({
  allowed,
  t,
  navigate,
  datePickerLocale,
  reportsOptions,
  selectedReportOption,
  salaLayouts,
  buyerCompaniesData,
  loadingLayout,
  loadingExportLogs,
  isDownloadEnabled,
  handlers,
  ...filterProps
}) => {
  if (!allowed) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.languageSelectorContainer}>
          <NotificationBell navigate={navigate} />
          <LanguageSelector />
        </div>
        <div className={styles.headerInfoContainer}>
          <div className={styles.headerInfo}>
            <DirectoryIcon />
            <h1 className={styles.title}>{t("pages.reports.header")}</h1>
          </div>
        </div>
      </div>
      <div className={styles.mainContent}>
        <div className={styles.selectorsContainer}>
          <ReportFilterPanels
            t={t}
            datePickerLocale={datePickerLocale}
            reportsOptions={reportsOptions}
            selectedReportOption={selectedReportOption}
            handlers={handlers}
            {...filterProps}
          />

          {(selectedReportOption?.value === REPORT_OPTION.TABLES ||
            selectedReportOption?.value === REPORT_OPTION.BUYER_LOGS) && (
            <div
              className={styles.generateReportButton}
              onClick={handlers.generateReportOnScreen}
            >
              {t("pages.reports.showOnScreen")}
            </div>
          )}
          {selectedReportOption?.value !== REPORT_OPTION.TABLES && (
            <div
              className={`${styles.downloadAuthenticationLogsButton} ${
                !isDownloadEnabled()
                  ? styles.downloadAuthenticationLogsButtonDisabled
                  : ""
              }`}
              onClick={isDownloadEnabled() ? handlers.downloadData : undefined}
            >
              {t("pages.reports.download")}
            </div>
          )}
        </div>

        <div className={styles.reportsContainer}>
          {loadingLayout && <p>{t("pages.reports.loadingReport")}</p>}
          {loadingExportLogs && <p>{t("pages.reports.loadingReport")}</p>}
          <div className={styles.tablesContainer}>
            {selectedReportOption?.value === REPORT_OPTION.TABLES &&
              !loadingLayout &&
              salaLayouts.map((sala) => (
                <RoomAccomodationReportTable key={sala._id ?? sala.id} room={sala} />
              ))}
            {selectedReportOption?.value === REPORT_OPTION.BUYER_LOGS &&
              !loadingLayout &&
              buyerCompaniesData.map((buyerCompany) => (
                <BuyerCompanyReportTable
                  key={buyerCompany._id ?? buyerCompany.id}
                  buyerCompany={buyerCompany}
                />
              ))}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ReportsView;
